// extracted by mini-css-extract-plugin
export default {"serviceSection":"serviceSection__NDQ5M","image":"image__ZDYyO","heading":"heading__MjhhN"};